import serviceBase from "./serviceBase";

const aiAssistant = {
  aiAssistantResponse: (data) =>
    serviceBase.post("/aiAssistant/assistant", data),
  aiLocationUpdate: (data) =>
    serviceBase.post("/aiAssistant/locationUpdate", data),
};
export default aiAssistant;
